module.exports = __webpack_public_path__ + "static/regina.52a849d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/regina.png
// module id = 2195
// module chunks = 61762850755587